import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value, unit = "₹") {
  if (unit === "₹") {
    return `₹${Number(value).toLocaleString('en-IN')}`;
  }
  return `${Number(value).toLocaleString()} ${unit}`;
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getToday() {
  return new Date().toISOString().split('T')[0];
}

export function getStatusColor(status) {
  const colors = {
    'Active': 'status-active',
    'Completed': 'status-completed',
    'Paused': 'status-paused',
    'Not Started': 'status-not-started',
    'In Progress': 'status-in-progress',
    'Done': 'status-done',
    'Open': 'status-active',
  };
  return colors[status] || 'status-not-started';
}

export function getDepartmentColor(dept) {
  const colors = {
    'Marketing': 'dept-marketing',
    'Sales': 'dept-sales',
    'Operations': 'dept-operations',
    'Finance': 'dept-finance',
    'R&D': 'dept-rd',
    'HR/People': 'dept-hr',
    'Admin': 'dept-admin',
  };
  return colors[dept] || 'dept-admin';
}

export function getHorizonColor(horizon) {
  const colors = {
    'Weekly': 'bg-blue-100 text-blue-700',
    '15-Day': 'bg-indigo-100 text-indigo-700',
    '30-Day': 'bg-purple-100 text-purple-700',
    '45-Day': 'bg-violet-100 text-violet-700',
    'Monthly': 'bg-pink-100 text-pink-700',
    '6-Month': 'bg-amber-100 text-amber-700',
    '1-Year': 'bg-emerald-100 text-emerald-700',
  };
  return colors[horizon] || 'bg-slate-100 text-slate-700';
}

export function calculateProgress(actual, target) {
  if (!target || target === 0) return 0;
  return Math.min(Math.round((actual / target) * 100), 100);
}
